import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { BaseCalendarContext } from '@libs/@core/components/date-picker/BaseCalendar';
import { isEndYear, isSelectedYear, isStartYear } from '@libs/@core/components/date-picker/utils/yearUtils';
var BaseCalendarYearContent = function (_a) {
    var selectedDate = _a.selectedDate;
    var _b = useContext(BaseCalendarContext), rangeYears = _b.rangeYears, multiple = _b.multiple, handleSelectYear = _b.handleSelectYear;
    var years = Array.from({ length: 10 }, function (_, index) { return rangeYears[0] + index; });
    return (_jsx("div", { className: 'grid grid-cols-3 gap-2 w-[250px]', children: years.map(function (year) {
            var yearDate = new Date(year, 0, 1); // Tạo đối tượng năm
            // Kiểm tra trạng thái của năm được chọn
            var isSelected = Array.isArray(selectedDate)
                ? isSelectedYear(yearDate, selectedDate) ||
                    isStartYear(yearDate, selectedDate) ||
                    isEndYear(yearDate, selectedDate)
                : isSelectedYear(yearDate, selectedDate);
            var selectRange = Array.isArray(selectedDate)
                ? "".concat(isStartYear(yearDate, selectedDate) ? 'rounded-l-md !bg-primary-main' : '', " ").concat(isEndYear(yearDate, selectedDate) ? 'rounded-r-md !bg-primary-main' : '')
                : '';
            return (_jsx("div", { onClick: function () { return handleSelectYear(year); }, className: "cursor-pointer h-10 w-full flex items-center justify-center text-sm focus:outline-none focus:ring-2 focus:ring-primary ".concat(selectRange, " ").concat(isSelected
                    ? "".concat(multiple ? 'bg-blue-300' : 'bg-primary-main rounded-md', "  text-white")
                    : 'hover:bg-gray-100 text-gray-700'), children: year }, year));
        }) }));
};
export default memo(BaseCalendarYearContent);
